import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

		if(!window.isMobile) {
			this.events = {
				mouseenter: {
					item: 'enterItem'
				},
				mouseleave: {
					item: 'leaveItem'
				}
			}
		}
    }

    init() {

    }

	enterItem() {
		html.classList.add('has-menu-item-hover');
	}

	leaveItem() {
		html.classList.remove('has-menu-item-hover');
	}
}
